import loadReCAPTCHAScript from "../../packages/Recaptcha";
import env from "../../utilities/env";

const RECAPTCHA_KEY = env("REACT_APP_RECAPTCHA_KEY");

export async function getReCAPTCHAToken() {
	if (!RECAPTCHA_KEY) throw new Error("reCAPTCHA key is not defined.");
	await loadReCAPTCHAScript(RECAPTCHA_KEY);
	await new Promise<void>((resolve, reject) => {
		if (!window.grecaptcha?.enterprise) {
			reject("Google reCAPTCHA Enterprise is not defined.");
		}
		window.grecaptcha.enterprise.ready(resolve);
	});
	return window.grecaptcha.enterprise.execute(RECAPTCHA_KEY, {
		action: "submit",
	});
}
